import React, {Component} from 'react';
import { HideUntilLoaded } from 'react-animation';
import AtividadeService from '../services/AtividadesService';
import ExtraService from '../services/ExtraService';
import AgendaService from '../services/AgendaService';
import { connect } from 'react-redux';


class Extra extends Component {
    css = {
        width: "100%"
    };

    state = {
        codigo:null,
        codigoAtividade: null,
        action:null,
        extra:null, 
        processando:false,
        redirecionando: false,
        erro: {
            isWrong: false,
            titulo: null,
            mensagem: null
        }
    }

    componentDidMount() {
        if (this.state.processando) {
            return
        }
        this.setState({processando:true})
        const codigo = this.props.match.params.codigo
        const codigoAtividade = this.props.match.params.codigoAtividade
        const service = new ExtraService()
        const agendaService = new AgendaService()
        service.iniciarConteudoExtra(codigo, codigoAtividade, (erro, action) => {
            this.setState({processando:false})
            if(action && action.dateFinished !== null){
                agendaService.atualizarAgenda(codigo, codigoAtividade, "EXTRA", null, null, (erro, sucesso) => {
                    if(erro){
                        alert( this.props.i18n.message("dinamica.erro.jaexecutada.mensagem", "Falha ao atualizar informações de atividade executadas, entre em contato com o suporte") )
                        return
                    }
                })
            }
            if (erro) {
                alert(JSON.stringify(erro))
                return
            }
           
            action.extra.css = {background: action.extra.theme.backgroundColor, color: action.extra.theme.foregroundColor, borderTopLeftRadius:'30px', borderTopRightRadius:'30px'}


            this.cssHeader = {}

            this.cssHeader.color = action.extra.theme.foregroundColor;

            this.setState({codigo:codigo,
                           codigoAtividade:codigoAtividade,
                           action:action, 
                           extra:action.extra})
        })
    }

    finalizarAtividadeERedirecionar = () => {
        const atividadeService = new AtividadeService();
        this.setState({redirecionando: true})
        atividadeService.finalizarAtividade(this.state.codigo, this.state.codigoAtividade, "EXTRA", {}, (erro, sucesso) => {
            if (erro) {
                alert(this.props.i18n.message("dinamica.erro.finalizar.mensagem", "Entre em contato com o suporte ou tente novamente mais tarde."),
                )

                return
            }
            const url = this.state.extra.url
            window.location = url
            this.setState({redirecionando: false})
            return
        })
    }



    render() {
        let i18n = this.props.i18n

        if (this.state.processando) {
            return <div>{ i18n.message("geral.aguarde", "Aguarde...") }</div>
        }
        if (this.state.redirecionando){
            return <div>{ i18n.message("geral.redirecionando", "Redirecionando para o conteúdo...") }</div>
        }
        const extra = this.state.extra
        if (! extra) {
            return <div>{ i18n.message("dinamica.extra.semConteudo", "Sem conteúdo...") }</div>
        }
        return (
            <>
        <div>
            <div>
                <div className="card weex-card-interno">
                    <header className="card-header" style={extra.css}>
                        <div className="card-header-title weex-card-header weex-card-header-atividade" style={this.cssHeader}>
                            {extra.title ? (extra.title) : (extra.theme.name)}
                        </div>
                    </header>
                    <div className="conteudo-card-atividades borda-lateral-e-inferior">
                    <div className="card-image mt-4">
                            <HideUntilLoaded style={this.css}>
                                <figure className="image weex-card-container-imagem">
                                    {
                                        extra.picture ?
                                        (
                                            <img src={extra.picture} alt="Imagem conteúdo extra" className="weex-card-imagem-coaching"/>
                                        ) :
                                        (
                                            <span></span>
                                        )
                                    }
                                </figure>
                            </HideUntilLoaded>
                        </div>
                        <div className="card-content">
                            <div className="content weex-card-interno__content">
                                <div dangerouslySetInnerHTML={  {__html: extra.presentation}   }></div>
                            </div>
                            <div style={{width:'100%', textAlign:'center'}}>
                                <button className="weex-button weex-botao-confirmacao" onClick={this.finalizarAtividadeERedirecionar}> {i18n.message("dinamica.extra.iniciar", "INICIAR")} </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        </>
        )
    }
}

const mapStateToProps = function(state) {
    return {
        i18n:state.i18n
    }
}

export default connect(mapStateToProps)(Extra)